module.exports = __webpack_public_path__ + "img/img_hotProduct_test.93684aec.png";